// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"pagination_breadCrumbs__nTMlN","navigation":"pagination_navigation__xRSf4"};